"use strict";
/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUtoken = exports.createUtoken = exports.deleteStorage = exports.updateStorage = exports.createStorage = exports.deleteUser = exports.updateUser = exports.createUser = exports.deleteNotification = exports.updateNotification = exports.createNotification = exports.deleteTransactionLog = exports.updateTransactionLog = exports.createTransactionLog = exports.deleteTransaction = exports.updateTransaction = exports.createTransaction = exports.deleteStorageTransaction = exports.updateStorageTransaction = exports.createStorageTransaction = exports.deleteBundle = exports.updateBundle = exports.createBundle = exports.deleteWhitelist = exports.updateWhitelist = exports.createWhitelist = exports.deleteMemo = exports.updateMemo = exports.createMemo = exports.deleteFolder = exports.updateFolder = exports.createFolder = exports.deleteFileVersion = exports.updateFileVersion = exports.createFileVersion = exports.deleteCollection = exports.updateCollection = exports.createCollection = exports.deleteNFT = exports.updateNFT = exports.createNFT = exports.deleteStack = exports.updateStack = exports.createStack = exports.deleteMembership = exports.updateMembership = exports.createMembership = exports.deleteVault = exports.updateVault = exports.createVault = void 0;
exports.deleteKeyMetric = exports.updateKeyMetric = exports.createKeyMetric = exports.deleteWebhookLog = exports.updateWebhookLog = exports.createWebhookLog = exports.deleteWebhook = exports.updateWebhook = exports.createWebhook = exports.deleteApiKey = exports.updateApiKey = exports.createApiKey = exports.deleteOrganisation = exports.updateOrganisation = exports.createOrganisation = exports.deletePaymentTransaction = exports.updatePaymentTransaction = exports.createPaymentTransaction = exports.deleteUtoken = void 0;
exports.createVault = `mutation CreateVault(
  $input: CreateVaultInput!
  $condition: ModelVaultConditionInput
) {
  createVault(input: $input, condition: $condition) {
    id
    membership {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    admin
    data
    description
    name
    owner
    public
    cloud
    blocked
    size
    status
    tags
    termsOfAccess
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateVault = `mutation UpdateVault(
  $input: UpdateVaultInput!
  $condition: ModelVaultConditionInput
) {
  updateVault(input: $input, condition: $condition) {
    id
    membership {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    admin
    data
    description
    name
    owner
    public
    cloud
    blocked
    size
    status
    tags
    termsOfAccess
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteVault = `mutation DeleteVault(
  $input: DeleteVaultInput!
  $condition: ModelVaultConditionInput
) {
  deleteVault(input: $input, condition: $condition) {
    id
    membership {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    admin
    data
    description
    name
    owner
    public
    cloud
    blocked
    size
    status
    tags
    termsOfAccess
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createMembership = `mutation CreateMembership(
  $input: CreateMembershipInput!
  $condition: ModelMembershipConditionInput
) {
  createMembership(input: $input, condition: $condition) {
    id
    address
    email
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    memberDetails {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    data
    expiresAt
    _ttl
    keys {
      encPrivateKey
      encPublicKey
      publicKey
      __typename
    }
    encPublicSigningKey
    message
    owner
    role
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateMembership = `mutation UpdateMembership(
  $input: UpdateMembershipInput!
  $condition: ModelMembershipConditionInput
) {
  updateMembership(input: $input, condition: $condition) {
    id
    address
    email
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    memberDetails {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    data
    expiresAt
    _ttl
    keys {
      encPrivateKey
      encPublicKey
      publicKey
      __typename
    }
    encPublicSigningKey
    message
    owner
    role
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteMembership = `mutation DeleteMembership(
  $input: DeleteMembershipInput!
  $condition: ModelMembershipConditionInput
) {
  deleteMembership(input: $input, condition: $condition) {
    id
    address
    email
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    memberDetails {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    data
    expiresAt
    _ttl
    keys {
      encPrivateKey
      encPublicKey
      publicKey
      __typename
    }
    encPublicSigningKey
    message
    owner
    role
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createStack = `mutation CreateStack(
  $input: CreateStackInput!
  $condition: ModelStackConditionInput
) {
  createStack(input: $input, condition: $condition) {
    id
    versions {
      items {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    vaultId
    parentId
    name
    owner
    status
    data
    tags
    size
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateStack = `mutation UpdateStack(
  $input: UpdateStackInput!
  $condition: ModelStackConditionInput
) {
  updateStack(input: $input, condition: $condition) {
    id
    versions {
      items {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    vaultId
    parentId
    name
    owner
    status
    data
    tags
    size
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteStack = `mutation DeleteStack(
  $input: DeleteStackInput!
  $condition: ModelStackConditionInput
) {
  deleteStack(input: $input, condition: $condition) {
    id
    versions {
      items {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    vaultId
    parentId
    name
    owner
    status
    data
    tags
    size
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createNFT = `mutation CreateNFT(
  $input: CreateNFTInput!
  $condition: ModelNFTConditionInput
) {
  createNFT(input: $input, condition: $condition) {
    id
    vaultId
    parentId
    name
    owner
    assetId
    asset {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    balances
    claimable {
      from
      qty
      to
      txID
      __typename
    }
    creator
    ticker
    description
    collection
    data
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateNFT = `mutation UpdateNFT(
  $input: UpdateNFTInput!
  $condition: ModelNFTConditionInput
) {
  updateNFT(input: $input, condition: $condition) {
    id
    vaultId
    parentId
    name
    owner
    assetId
    asset {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    balances
    claimable {
      from
      qty
      to
      txID
      __typename
    }
    creator
    ticker
    description
    collection
    data
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteNFT = `mutation DeleteNFT(
  $input: DeleteNFTInput!
  $condition: ModelNFTConditionInput
) {
  deleteNFT(input: $input, condition: $condition) {
    id
    vaultId
    parentId
    name
    owner
    assetId
    asset {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    balances
    claimable {
      from
      qty
      to
      txID
      __typename
    }
    creator
    ticker
    description
    collection
    data
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createCollection = `mutation CreateCollection(
  $input: CreateCollectionInput!
  $condition: ModelCollectionConditionInput
) {
  createCollection(input: $input, condition: $condition) {
    id
    vaultId
    parentId
    name
    description
    owner
    bannerId
    banner {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    code
    creator
    items
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    data
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateCollection = `mutation UpdateCollection(
  $input: UpdateCollectionInput!
  $condition: ModelCollectionConditionInput
) {
  updateCollection(input: $input, condition: $condition) {
    id
    vaultId
    parentId
    name
    description
    owner
    bannerId
    banner {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    code
    creator
    items
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    data
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteCollection = `mutation DeleteCollection(
  $input: DeleteCollectionInput!
  $condition: ModelCollectionConditionInput
) {
  deleteCollection(input: $input, condition: $condition) {
    id
    vaultId
    parentId
    name
    description
    owner
    bannerId
    banner {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    thumbnailId
    thumbnail {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    code
    creator
    items
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    data
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createFileVersion = `mutation CreateFileVersion(
  $input: CreateFileVersionInput!
  $condition: ModelFileVersionConditionInput
) {
  createFileVersion(input: $input, condition: $condition) {
    id
    nodeId
    owner
    storageTransactionId
    storageTransaction {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    name
    chunkSize
    numberOfChunks
    resourceUri
    size
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    status
    external
    nodeType
    tags
    class
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateFileVersion = `mutation UpdateFileVersion(
  $input: UpdateFileVersionInput!
  $condition: ModelFileVersionConditionInput
) {
  updateFileVersion(input: $input, condition: $condition) {
    id
    nodeId
    owner
    storageTransactionId
    storageTransaction {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    name
    chunkSize
    numberOfChunks
    resourceUri
    size
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    status
    external
    nodeType
    tags
    class
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteFileVersion = `mutation DeleteFileVersion(
  $input: DeleteFileVersionInput!
  $condition: ModelFileVersionConditionInput
) {
  deleteFileVersion(input: $input, condition: $condition) {
    id
    nodeId
    owner
    storageTransactionId
    storageTransaction {
      id
      owner
      txId
      txFee
      dataItemId
      fileVersion {
        id
        nodeId
        owner
        storageTransactionId
        storageTransaction {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        name
        chunkSize
        numberOfChunks
        resourceUri
        size
        type
        ucm
        udl {
          commercialUses {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          currency
          derivations {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          dataModelTrainings {
            duration {
              type
              value
              __typename
            }
            fee {
              type
              value
              __typename
            }
            type
            value
            __typename
          }
          expires
          license
          licenseFee {
            type
            value
            __typename
          }
          paymentAddress
          paymentMode
          unknownUsageRights
          __typename
        }
        status
        external
        nodeType
        tags
        class
        _ttl
        createdAt
        updatedAt
        __typename
      }
      bundleId
      bundle {
        id
        txId
        txFee
        status
        dataItem {
          items {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        uploadCount
        dataItemsCount
        size
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      members {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      class
      vaultId
      nodeId
      nodeType
      status
      type
      uploadCount
      size
      verificationId
      verificationCount
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    name
    chunkSize
    numberOfChunks
    resourceUri
    size
    type
    ucm
    udl {
      commercialUses {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      currency
      derivations {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      dataModelTrainings {
        duration {
          type
          value
          __typename
        }
        fee {
          type
          value
          __typename
        }
        type
        value
        __typename
      }
      expires
      license
      licenseFee {
        type
        value
        __typename
      }
      paymentAddress
      paymentMode
      unknownUsageRights
      __typename
    }
    status
    external
    nodeType
    tags
    class
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createFolder = `mutation CreateFolder(
  $input: CreateFolderInput!
  $condition: ModelFolderConditionInput
) {
  createFolder(input: $input, condition: $condition) {
    id
    vaultId
    parentId
    data
    name
    owner
    size
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateFolder = `mutation UpdateFolder(
  $input: UpdateFolderInput!
  $condition: ModelFolderConditionInput
) {
  updateFolder(input: $input, condition: $condition) {
    id
    vaultId
    parentId
    data
    name
    owner
    size
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteFolder = `mutation DeleteFolder(
  $input: DeleteFolderInput!
  $condition: ModelFolderConditionInput
) {
  deleteFolder(input: $input, condition: $condition) {
    id
    vaultId
    parentId
    data
    name
    owner
    size
    status
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createMemo = `mutation CreateMemo(
  $input: CreateMemoInput!
  $condition: ModelMemoConditionInput
) {
  createMemo(input: $input, condition: $condition) {
    id
    vaultId
    data
    owner
    status
    versions {
      message
      owner
      reactions {
        owner
        reaction
        createdAt
        __typename
      }
      attachments
      createdAt
      __typename
    }
    parentId
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateMemo = `mutation UpdateMemo(
  $input: UpdateMemoInput!
  $condition: ModelMemoConditionInput
) {
  updateMemo(input: $input, condition: $condition) {
    id
    vaultId
    data
    owner
    status
    versions {
      message
      owner
      reactions {
        owner
        reaction
        createdAt
        __typename
      }
      attachments
      createdAt
      __typename
    }
    parentId
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteMemo = `mutation DeleteMemo(
  $input: DeleteMemoInput!
  $condition: ModelMemoConditionInput
) {
  deleteMemo(input: $input, condition: $condition) {
    id
    vaultId
    data
    owner
    status
    versions {
      message
      owner
      reactions {
        owner
        reaction
        createdAt
        __typename
      }
      attachments
      createdAt
      __typename
    }
    parentId
    tags
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createWhitelist = `mutation CreateWhitelist(
  $input: CreateWhitelistInput!
  $condition: ModelWhitelistConditionInput
) {
  createWhitelist(input: $input, condition: $condition) {
    id
    vaultId
    owner
    type
    token
    capacity
    access
    members {
      address
      email
      externalAddress
      __typename
    }
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateWhitelist = `mutation UpdateWhitelist(
  $input: UpdateWhitelistInput!
  $condition: ModelWhitelistConditionInput
) {
  updateWhitelist(input: $input, condition: $condition) {
    id
    vaultId
    owner
    type
    token
    capacity
    access
    members {
      address
      email
      externalAddress
      __typename
    }
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteWhitelist = `mutation DeleteWhitelist(
  $input: DeleteWhitelistInput!
  $condition: ModelWhitelistConditionInput
) {
  deleteWhitelist(input: $input, condition: $condition) {
    id
    vaultId
    owner
    type
    token
    capacity
    access
    members {
      address
      email
      externalAddress
      __typename
    }
    status
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createBundle = `mutation CreateBundle(
  $input: CreateBundleInput!
  $condition: ModelBundleConditionInput
) {
  createBundle(input: $input, condition: $condition) {
    id
    txId
    txFee
    status
    dataItem {
      items {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    uploadCount
    dataItemsCount
    size
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateBundle = `mutation UpdateBundle(
  $input: UpdateBundleInput!
  $condition: ModelBundleConditionInput
) {
  updateBundle(input: $input, condition: $condition) {
    id
    txId
    txFee
    status
    dataItem {
      items {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    uploadCount
    dataItemsCount
    size
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteBundle = `mutation DeleteBundle(
  $input: DeleteBundleInput!
  $condition: ModelBundleConditionInput
) {
  deleteBundle(input: $input, condition: $condition) {
    id
    txId
    txFee
    status
    dataItem {
      items {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    uploadCount
    dataItemsCount
    size
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createStorageTransaction = `mutation CreateStorageTransaction(
  $input: CreateStorageTransactionInput!
  $condition: ModelStorageTransactionConditionInput
) {
  createStorageTransaction(input: $input, condition: $condition) {
    id
    owner
    txId
    txFee
    dataItemId
    fileVersion {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    bundleId
    bundle {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    members {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    class
    vaultId
    nodeId
    nodeType
    status
    type
    uploadCount
    size
    verificationId
    verificationCount
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateStorageTransaction = `mutation UpdateStorageTransaction(
  $input: UpdateStorageTransactionInput!
  $condition: ModelStorageTransactionConditionInput
) {
  updateStorageTransaction(input: $input, condition: $condition) {
    id
    owner
    txId
    txFee
    dataItemId
    fileVersion {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    bundleId
    bundle {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    members {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    class
    vaultId
    nodeId
    nodeType
    status
    type
    uploadCount
    size
    verificationId
    verificationCount
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteStorageTransaction = `mutation DeleteStorageTransaction(
  $input: DeleteStorageTransactionInput!
  $condition: ModelStorageTransactionConditionInput
) {
  deleteStorageTransaction(input: $input, condition: $condition) {
    id
    owner
    txId
    txFee
    dataItemId
    fileVersion {
      id
      nodeId
      owner
      storageTransactionId
      storageTransaction {
        id
        owner
        txId
        txFee
        dataItemId
        fileVersion {
          id
          nodeId
          owner
          storageTransactionId
          storageTransaction {
            id
            owner
            txId
            txFee
            dataItemId
            fileVersion {
              id
              nodeId
              owner
              storageTransactionId
              name
              chunkSize
              numberOfChunks
              resourceUri
              size
              type
              ucm
              status
              external
              nodeType
              tags
              class
              _ttl
              createdAt
              updatedAt
              __typename
            }
            bundleId
            bundle {
              id
              txId
              txFee
              status
              uploadCount
              dataItemsCount
              size
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            members {
              nextToken
              __typename
            }
            class
            vaultId
            nodeId
            nodeType
            status
            type
            uploadCount
            size
            verificationId
            verificationCount
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          name
          chunkSize
          numberOfChunks
          resourceUri
          size
          type
          ucm
          udl {
            commercialUses {
              type
              value
              __typename
            }
            currency
            derivations {
              type
              value
              __typename
            }
            dataModelTrainings {
              type
              value
              __typename
            }
            expires
            license
            licenseFee {
              type
              value
              __typename
            }
            paymentAddress
            paymentMode
            unknownUsageRights
            __typename
          }
          status
          external
          nodeType
          tags
          class
          _ttl
          createdAt
          updatedAt
          __typename
        }
        bundleId
        bundle {
          id
          txId
          txFee
          status
          dataItem {
            items {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          uploadCount
          dataItemsCount
          size
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        members {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        class
        vaultId
        nodeId
        nodeType
        status
        type
        uploadCount
        size
        verificationId
        verificationCount
        signedBy
        signature
        payedBy
        createdAt
        updatedAt
        __typename
      }
      name
      chunkSize
      numberOfChunks
      resourceUri
      size
      type
      ucm
      udl {
        commercialUses {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        currency
        derivations {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        dataModelTrainings {
          duration {
            type
            value
            __typename
          }
          fee {
            type
            value
            __typename
          }
          type
          value
          __typename
        }
        expires
        license
        licenseFee {
          type
          value
          __typename
        }
        paymentAddress
        paymentMode
        unknownUsageRights
        __typename
      }
      status
      external
      nodeType
      tags
      class
      _ttl
      createdAt
      updatedAt
      __typename
    }
    bundleId
    bundle {
      id
      txId
      txFee
      status
      dataItem {
        items {
          id
          owner
          txId
          txFee
          dataItemId
          fileVersion {
            id
            nodeId
            owner
            storageTransactionId
            storageTransaction {
              id
              owner
              txId
              txFee
              dataItemId
              bundleId
              class
              vaultId
              nodeId
              nodeType
              status
              type
              uploadCount
              size
              verificationId
              verificationCount
              signedBy
              signature
              payedBy
              createdAt
              updatedAt
              __typename
            }
            name
            chunkSize
            numberOfChunks
            resourceUri
            size
            type
            ucm
            udl {
              currency
              expires
              license
              paymentAddress
              paymentMode
              unknownUsageRights
              __typename
            }
            status
            external
            nodeType
            tags
            class
            _ttl
            createdAt
            updatedAt
            __typename
          }
          bundleId
          bundle {
            id
            txId
            txFee
            status
            dataItem {
              nextToken
              __typename
            }
            uploadCount
            dataItemsCount
            size
            signedBy
            signature
            payedBy
            createdAt
            updatedAt
            __typename
          }
          members {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          class
          vaultId
          nodeId
          nodeType
          status
          type
          uploadCount
          size
          verificationId
          verificationCount
          signedBy
          signature
          payedBy
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      uploadCount
      dataItemsCount
      size
      signedBy
      signature
      payedBy
      createdAt
      updatedAt
      __typename
    }
    members {
      items {
        id
        address
        email
        vaultId
        vault {
          id
          membership {
            items {
              id
              address
              email
              vaultId
              data
              expiresAt
              _ttl
              encPublicSigningKey
              message
              owner
              role
              status
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          admin
          data
          description
          name
          owner
          public
          cloud
          blocked
          size
          status
          tags
          termsOfAccess
          createdAt
          updatedAt
          __typename
        }
        memberDetails {
          address
          email
          referralId
          avatar
          profileName
          publicKey
          publicSigningKey
          metadata
          orgId
          orgRole
          _ttl
          createdAt
          updatedAt
          organisationUsersId
          __typename
        }
        data
        expiresAt
        _ttl
        keys {
          encPrivateKey
          encPublicKey
          publicKey
          __typename
        }
        encPublicSigningKey
        message
        owner
        role
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    class
    vaultId
    nodeId
    nodeType
    status
    type
    uploadCount
    size
    verificationId
    verificationCount
    signedBy
    signature
    payedBy
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createTransaction = `mutation CreateTransaction(
  $input: CreateTransactionInput!
  $condition: ModelTransactionConditionInput
) {
  createTransaction(input: $input, condition: $condition) {
    id
    txId
    function
    owner
    vaultId
    actionRef
    groupRef
    objectId
    objectType
    data
    input
    referrer
    status
    tags
    cloud
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateTransaction = `mutation UpdateTransaction(
  $input: UpdateTransactionInput!
  $condition: ModelTransactionConditionInput
) {
  updateTransaction(input: $input, condition: $condition) {
    id
    txId
    function
    owner
    vaultId
    actionRef
    groupRef
    objectId
    objectType
    data
    input
    referrer
    status
    tags
    cloud
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteTransaction = `mutation DeleteTransaction(
  $input: DeleteTransactionInput!
  $condition: ModelTransactionConditionInput
) {
  deleteTransaction(input: $input, condition: $condition) {
    id
    txId
    function
    owner
    vaultId
    actionRef
    groupRef
    objectId
    objectType
    data
    input
    referrer
    status
    tags
    cloud
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createTransactionLog = `mutation CreateTransactionLog(
  $input: CreateTransactionLogInput!
  $condition: ModelTransactionLogConditionInput
) {
  createTransactionLog(input: $input, condition: $condition) {
    id
    owner
    actionRef
    admin
    content
    vaultId
    groupRef
    hash
    objectId
    objectType
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateTransactionLog = `mutation UpdateTransactionLog(
  $input: UpdateTransactionLogInput!
  $condition: ModelTransactionLogConditionInput
) {
  updateTransactionLog(input: $input, condition: $condition) {
    id
    owner
    actionRef
    admin
    content
    vaultId
    groupRef
    hash
    objectId
    objectType
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteTransactionLog = `mutation DeleteTransactionLog(
  $input: DeleteTransactionLogInput!
  $condition: ModelTransactionLogConditionInput
) {
  deleteTransactionLog(input: $input, condition: $condition) {
    id
    owner
    actionRef
    admin
    content
    vaultId
    groupRef
    hash
    objectId
    objectType
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createNotification = `mutation CreateNotification(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotification(input: $input, condition: $condition) {
    id
    fromAddress
    from {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toAddress
    to {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toMemberId
    toMember {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    toEmail
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    objectId
    objectType
    objectName
    event
    channels
    content
    status
    priority
    activity
    admin
    count
    host
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateNotification = `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    id
    fromAddress
    from {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toAddress
    to {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toMemberId
    toMember {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    toEmail
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    objectId
    objectType
    objectName
    event
    channels
    content
    status
    priority
    activity
    admin
    count
    host
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteNotification = `mutation DeleteNotification(
  $input: DeleteNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  deleteNotification(input: $input, condition: $condition) {
    id
    fromAddress
    from {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toAddress
    to {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    toMemberId
    toMember {
      id
      address
      email
      vaultId
      vault {
        id
        membership {
          items {
            id
            address
            email
            vaultId
            vault {
              id
              admin
              data
              description
              name
              owner
              public
              cloud
              blocked
              size
              status
              tags
              termsOfAccess
              createdAt
              updatedAt
              __typename
            }
            memberDetails {
              address
              email
              referralId
              avatar
              profileName
              publicKey
              publicSigningKey
              metadata
              orgId
              orgRole
              _ttl
              createdAt
              updatedAt
              organisationUsersId
              __typename
            }
            data
            expiresAt
            _ttl
            keys {
              encPrivateKey
              encPublicKey
              publicKey
              __typename
            }
            encPublicSigningKey
            message
            owner
            role
            status
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        admin
        data
        description
        name
        owner
        public
        cloud
        blocked
        size
        status
        tags
        termsOfAccess
        createdAt
        updatedAt
        __typename
      }
      memberDetails {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      data
      expiresAt
      _ttl
      keys {
        encPrivateKey
        encPublicKey
        publicKey
        __typename
      }
      encPublicSigningKey
      message
      owner
      role
      status
      createdAt
      updatedAt
      __typename
    }
    toEmail
    vaultId
    vault {
      id
      membership {
        items {
          id
          address
          email
          vaultId
          vault {
            id
            membership {
              nextToken
              __typename
            }
            admin
            data
            description
            name
            owner
            public
            cloud
            blocked
            size
            status
            tags
            termsOfAccess
            createdAt
            updatedAt
            __typename
          }
          memberDetails {
            address
            email
            referralId
            avatar
            profileName
            publicKey
            publicSigningKey
            metadata
            orgId
            orgRole
            _ttl
            createdAt
            updatedAt
            organisationUsersId
            __typename
          }
          data
          expiresAt
          _ttl
          keys {
            encPrivateKey
            encPublicKey
            publicKey
            __typename
          }
          encPublicSigningKey
          message
          owner
          role
          status
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      admin
      data
      description
      name
      owner
      public
      cloud
      blocked
      size
      status
      tags
      termsOfAccess
      createdAt
      updatedAt
      __typename
    }
    objectId
    objectType
    objectName
    event
    channels
    content
    status
    priority
    activity
    admin
    count
    host
    _ttl
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createUser = `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    address
    email
    referralId
    avatar
    profileName
    publicKey
    publicSigningKey
    metadata
    orgId
    orgRole
    _ttl
    createdAt
    updatedAt
    organisationUsersId
    __typename
  }
}
`;
exports.updateUser = `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    address
    email
    referralId
    avatar
    profileName
    publicKey
    publicSigningKey
    metadata
    orgId
    orgRole
    _ttl
    createdAt
    updatedAt
    organisationUsersId
    __typename
  }
}
`;
exports.deleteUser = `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    address
    email
    referralId
    avatar
    profileName
    publicKey
    publicSigningKey
    metadata
    orgId
    orgRole
    _ttl
    createdAt
    updatedAt
    organisationUsersId
    __typename
  }
}
`;
exports.createStorage = `mutation CreateStorage(
  $input: CreateStorageInput!
  $condition: ModelStorageConditionInput
) {
  createStorage(input: $input, condition: $condition) {
    address
    cloud_audio
    cloud_documents
    cloud_notes
    cloud_other
    cloud_photos
    cloud_storage_available
    cloud_storage_total
    cloud_video
    audio
    documents
    notes
    other
    photos
    video
    storage_available
    storage_total
    u_balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateStorage = `mutation UpdateStorage(
  $input: UpdateStorageInput!
  $condition: ModelStorageConditionInput
) {
  updateStorage(input: $input, condition: $condition) {
    address
    cloud_audio
    cloud_documents
    cloud_notes
    cloud_other
    cloud_photos
    cloud_storage_available
    cloud_storage_total
    cloud_video
    audio
    documents
    notes
    other
    photos
    video
    storage_available
    storage_total
    u_balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteStorage = `mutation DeleteStorage(
  $input: DeleteStorageInput!
  $condition: ModelStorageConditionInput
) {
  deleteStorage(input: $input, condition: $condition) {
    address
    cloud_audio
    cloud_documents
    cloud_notes
    cloud_other
    cloud_photos
    cloud_storage_available
    cloud_storage_total
    cloud_video
    audio
    documents
    notes
    other
    photos
    video
    storage_available
    storage_total
    u_balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createUtoken = `mutation CreateUtoken(
  $input: CreateUtokenInput!
  $condition: ModelUtokenConditionInput
) {
  createUtoken(input: $input, condition: $condition) {
    address
    balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateUtoken = `mutation UpdateUtoken(
  $input: UpdateUtokenInput!
  $condition: ModelUtokenConditionInput
) {
  updateUtoken(input: $input, condition: $condition) {
    address
    balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteUtoken = `mutation DeleteUtoken(
  $input: DeleteUtokenInput!
  $condition: ModelUtokenConditionInput
) {
  deleteUtoken(input: $input, condition: $condition) {
    address
    balance
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createPaymentTransaction = `mutation CreatePaymentTransaction(
  $input: CreatePaymentTransactionInput!
  $condition: ModelPaymentTransactionConditionInput
) {
  createPaymentTransaction(input: $input, condition: $condition) {
    cart {
      amount
      currency
      priceId
      productId
      promo
      storage
      __typename
    }
    createdAt
    invoiceNumber
    paidAt
    paymentIntentId
    owner
    receiptNumber
    status
    updatedAt
    __typename
  }
}
`;
exports.updatePaymentTransaction = `mutation UpdatePaymentTransaction(
  $input: UpdatePaymentTransactionInput!
  $condition: ModelPaymentTransactionConditionInput
) {
  updatePaymentTransaction(input: $input, condition: $condition) {
    cart {
      amount
      currency
      priceId
      productId
      promo
      storage
      __typename
    }
    createdAt
    invoiceNumber
    paidAt
    paymentIntentId
    owner
    receiptNumber
    status
    updatedAt
    __typename
  }
}
`;
exports.deletePaymentTransaction = `mutation DeletePaymentTransaction(
  $input: DeletePaymentTransactionInput!
  $condition: ModelPaymentTransactionConditionInput
) {
  deletePaymentTransaction(input: $input, condition: $condition) {
    cart {
      amount
      currency
      priceId
      productId
      promo
      storage
      __typename
    }
    createdAt
    invoiceNumber
    paidAt
    paymentIntentId
    owner
    receiptNumber
    status
    updatedAt
    __typename
  }
}
`;
exports.createOrganisation = `mutation CreateOrganisation(
  $input: CreateOrganisationInput!
  $condition: ModelOrganisationConditionInput
) {
  createOrganisation(input: $input, condition: $condition) {
    id
    subdomain
    name
    logoBase64
    primaryColor
    secondaryColor
    owner
    email
    users {
      items {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateOrganisation = `mutation UpdateOrganisation(
  $input: UpdateOrganisationInput!
  $condition: ModelOrganisationConditionInput
) {
  updateOrganisation(input: $input, condition: $condition) {
    id
    subdomain
    name
    logoBase64
    primaryColor
    secondaryColor
    owner
    email
    users {
      items {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteOrganisation = `mutation DeleteOrganisation(
  $input: DeleteOrganisationInput!
  $condition: ModelOrganisationConditionInput
) {
  deleteOrganisation(input: $input, condition: $condition) {
    id
    subdomain
    name
    logoBase64
    primaryColor
    secondaryColor
    owner
    email
    users {
      items {
        address
        email
        referralId
        avatar
        profileName
        publicKey
        publicSigningKey
        metadata
        orgId
        orgRole
        _ttl
        createdAt
        updatedAt
        organisationUsersId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createApiKey = `mutation CreateApiKey(
  $input: CreateApiKeyInput!
  $condition: ModelApiKeyConditionInput
) {
  createApiKey(input: $input, condition: $condition) {
    key
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateApiKey = `mutation UpdateApiKey(
  $input: UpdateApiKeyInput!
  $condition: ModelApiKeyConditionInput
) {
  updateApiKey(input: $input, condition: $condition) {
    key
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteApiKey = `mutation DeleteApiKey(
  $input: DeleteApiKeyInput!
  $condition: ModelApiKeyConditionInput
) {
  deleteApiKey(input: $input, condition: $condition) {
    key
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createWebhook = `mutation CreateWebhook(
  $input: CreateWebhookInput!
  $condition: ModelWebhookConditionInput
) {
  createWebhook(input: $input, condition: $condition) {
    id
    url
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.updateWebhook = `mutation UpdateWebhook(
  $input: UpdateWebhookInput!
  $condition: ModelWebhookConditionInput
) {
  updateWebhook(input: $input, condition: $condition) {
    id
    url
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.deleteWebhook = `mutation DeleteWebhook(
  $input: DeleteWebhookInput!
  $condition: ModelWebhookConditionInput
) {
  deleteWebhook(input: $input, condition: $condition) {
    id
    url
    address
    user {
      address
      email
      referralId
      avatar
      profileName
      publicKey
      publicSigningKey
      metadata
      orgId
      orgRole
      _ttl
      createdAt
      updatedAt
      organisationUsersId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
`;
exports.createWebhookLog = `mutation CreateWebhookLog(
  $input: CreateWebhookLogInput!
  $condition: ModelWebhookLogConditionInput
) {
  createWebhookLog(input: $input, condition: $condition) {
    id
    url
    address
    event
    requestBody
    responseBody
    responseStatusCode
    createdAt
    deliveryStatus
    updatedAt
    __typename
  }
}
`;
exports.updateWebhookLog = `mutation UpdateWebhookLog(
  $input: UpdateWebhookLogInput!
  $condition: ModelWebhookLogConditionInput
) {
  updateWebhookLog(input: $input, condition: $condition) {
    id
    url
    address
    event
    requestBody
    responseBody
    responseStatusCode
    createdAt
    deliveryStatus
    updatedAt
    __typename
  }
}
`;
exports.deleteWebhookLog = `mutation DeleteWebhookLog(
  $input: DeleteWebhookLogInput!
  $condition: ModelWebhookLogConditionInput
) {
  deleteWebhookLog(input: $input, condition: $condition) {
    id
    url
    address
    event
    requestBody
    responseBody
    responseStatusCode
    createdAt
    deliveryStatus
    updatedAt
    __typename
  }
}
`;
exports.createKeyMetric = `mutation CreateKeyMetric(
  $input: CreateKeyMetricInput!
  $condition: ModelKeyMetricConditionInput
) {
  createKeyMetric(input: $input, condition: $condition) {
    available_funds
    createdAt
    daily_arweave_uploads
    daily_audio_uploads
    daily_audio_uploads_size
    daily_banned_uploads
    daily_blocked_uploads
    daily_churn
    daily_cloud_uploads
    daily_committed_storage
    daily_committed_uploads
    daily_committed_uploads_duration
    daily_documents_uploads
    daily_documents_uploads_size
    daily_expenses_eur
    daily_invites_accepted
    daily_invites_sent
    daily_ipfs_uploads
    daily_memos
    daily_new_users
    daily_other_uploads
    daily_other_uploads_size
    daily_payments
    daily_pending_uploads
    daily_photos_uploads
    daily_photos_uploads_size
    daily_rejected_uploads
    daily_reposted_twice_uploads
    daily_reposted_uploads
    daily_revenue_eur
    daily_scheduled_uploads
    daily_transactions
    daily_uploads
    daily_uploads_size
    daily_used_storage
    daily_users_activity {
      location
      users_count
      __typename
    }
    daily_vaults
    daily_video_uploads
    daily_video_uploads_size
    date
    id
    monthly_active_users_count
    monthly_active_users_list
    total_active_users
    total_arweave_uploads
    total_audio_uploads
    total_audio_uploads_size
    total_banned_uploads
    total_blocked_uploads
    total_cloud_uploads
    total_committed_storage
    total_committed_uploads
    total_documents_uploads
    total_documents_uploads_size
    total_expenses_eur
    total_inactive_users
    total_invites_sent
    total_invites_unaccepted
    total_ipfs_uploads
    total_memos
    total_other_uploads
    total_other_uploads_size
    total_payments
    total_pending_uploads
    total_photos_uploads
    total_photos_uploads_size
    total_rejected_uploads
    total_reposted_twice_uploads
    total_reposted_uploads
    total_revenue_eur
    total_scheduled_uploads
    total_transactions
    total_uploads
    total_uploads_size
    total_used_storage
    total_vaults
    total_video_uploads
    total_video_uploads_size
    updatedAt
    __typename
  }
}
`;
exports.updateKeyMetric = `mutation UpdateKeyMetric(
  $input: UpdateKeyMetricInput!
  $condition: ModelKeyMetricConditionInput
) {
  updateKeyMetric(input: $input, condition: $condition) {
    available_funds
    createdAt
    daily_arweave_uploads
    daily_audio_uploads
    daily_audio_uploads_size
    daily_banned_uploads
    daily_blocked_uploads
    daily_churn
    daily_cloud_uploads
    daily_committed_storage
    daily_committed_uploads
    daily_committed_uploads_duration
    daily_documents_uploads
    daily_documents_uploads_size
    daily_expenses_eur
    daily_invites_accepted
    daily_invites_sent
    daily_ipfs_uploads
    daily_memos
    daily_new_users
    daily_other_uploads
    daily_other_uploads_size
    daily_payments
    daily_pending_uploads
    daily_photos_uploads
    daily_photos_uploads_size
    daily_rejected_uploads
    daily_reposted_twice_uploads
    daily_reposted_uploads
    daily_revenue_eur
    daily_scheduled_uploads
    daily_transactions
    daily_uploads
    daily_uploads_size
    daily_used_storage
    daily_users_activity {
      location
      users_count
      __typename
    }
    daily_vaults
    daily_video_uploads
    daily_video_uploads_size
    date
    id
    monthly_active_users_count
    monthly_active_users_list
    total_active_users
    total_arweave_uploads
    total_audio_uploads
    total_audio_uploads_size
    total_banned_uploads
    total_blocked_uploads
    total_cloud_uploads
    total_committed_storage
    total_committed_uploads
    total_documents_uploads
    total_documents_uploads_size
    total_expenses_eur
    total_inactive_users
    total_invites_sent
    total_invites_unaccepted
    total_ipfs_uploads
    total_memos
    total_other_uploads
    total_other_uploads_size
    total_payments
    total_pending_uploads
    total_photos_uploads
    total_photos_uploads_size
    total_rejected_uploads
    total_reposted_twice_uploads
    total_reposted_uploads
    total_revenue_eur
    total_scheduled_uploads
    total_transactions
    total_uploads
    total_uploads_size
    total_used_storage
    total_vaults
    total_video_uploads
    total_video_uploads_size
    updatedAt
    __typename
  }
}
`;
exports.deleteKeyMetric = `mutation DeleteKeyMetric(
  $input: DeleteKeyMetricInput!
  $condition: ModelKeyMetricConditionInput
) {
  deleteKeyMetric(input: $input, condition: $condition) {
    available_funds
    createdAt
    daily_arweave_uploads
    daily_audio_uploads
    daily_audio_uploads_size
    daily_banned_uploads
    daily_blocked_uploads
    daily_churn
    daily_cloud_uploads
    daily_committed_storage
    daily_committed_uploads
    daily_committed_uploads_duration
    daily_documents_uploads
    daily_documents_uploads_size
    daily_expenses_eur
    daily_invites_accepted
    daily_invites_sent
    daily_ipfs_uploads
    daily_memos
    daily_new_users
    daily_other_uploads
    daily_other_uploads_size
    daily_payments
    daily_pending_uploads
    daily_photos_uploads
    daily_photos_uploads_size
    daily_rejected_uploads
    daily_reposted_twice_uploads
    daily_reposted_uploads
    daily_revenue_eur
    daily_scheduled_uploads
    daily_transactions
    daily_uploads
    daily_uploads_size
    daily_used_storage
    daily_users_activity {
      location
      users_count
      __typename
    }
    daily_vaults
    daily_video_uploads
    daily_video_uploads_size
    date
    id
    monthly_active_users_count
    monthly_active_users_list
    total_active_users
    total_arweave_uploads
    total_audio_uploads
    total_audio_uploads_size
    total_banned_uploads
    total_blocked_uploads
    total_cloud_uploads
    total_committed_storage
    total_committed_uploads
    total_documents_uploads
    total_documents_uploads_size
    total_expenses_eur
    total_inactive_users
    total_invites_sent
    total_invites_unaccepted
    total_ipfs_uploads
    total_memos
    total_other_uploads
    total_other_uploads_size
    total_payments
    total_pending_uploads
    total_photos_uploads
    total_photos_uploads_size
    total_rejected_uploads
    total_reposted_twice_uploads
    total_reposted_uploads
    total_revenue_eur
    total_scheduled_uploads
    total_transactions
    total_uploads
    total_uploads_size
    total_used_storage
    total_vaults
    total_video_uploads
    total_video_uploads_size
    updatedAt
    __typename
  }
}
`;
